const PATHS = {
  ROOT: "/",
  HOME: "/home",
  SERVICES: "/services",
  ABOUT: "/about",
  CONTACT: "/contact",
  ANNOUNCEMENTS: "/announcements",
  CATEGORIES: "/categories",
  CATEGORY: "/categories/:categoryId",
  ANNOUNCEMENT: "/announcements/:announcementId",
  USER_MANAGEMENT: "/admin/users",
  NOT_AUTHORIZED: "/not-authorized",
};

export default PATHS;
